


import { Brain, Sparkles, Zap, TreeDeciduous, ArrowRight, MessageSquare, Download } from "lucide-react";
import { useState } from "react";
import { WaitlistDialog } from "./WaitlistDialog";
import WhatsAppPromo from "./WhatsAppPromo";
import { Button } from "./ui/button";

const Hero = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isWhatsAppPromoOpen, setIsWhatsAppPromoOpen] = useState(false);

  const handleTagClick = () => {
    window.location.reload();
  };

  return (
    <main className="relative min-h-screen flex flex-col" aria-labelledby="hero-title">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50 -z-10" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 sm:pt-40 flex-grow">
          <header className="mb-16">
            <h1 id="hero-title" className="flex flex-col items-center text-center gap-4 text-4xl sm:text-5xl md:text-6xl font-bold mb-8 animate-fadeIn">
              <span className="w-full"><span className="text-[#0066FF]">DeepSeek AI</span> Domain For Sale</span>
              <span className="text-2xl sm:text-3xl md:text-4xl text-gray-600 w-full">Premium AI Domain Name - Submit Your Bid Today</span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto text-center animate-fadeIn" style={{ animationDelay: "0.2s" }}>
              DeepSeek AI is a premium domain name perfect for AI startups, research organizations, and technology companies focused on cutting-edge artificial intelligence solutions and language models.
            </p>

            {/* Main prominent download button */}
            <div className="flex justify-center mb-8 animate-fadeIn" style={{ animationDelay: "0.3s" }}>
              <a
                href="https://chromewebstore.google.com/detail/deepseek/inhcgfpbfdjbjogdfjbclgolkmhnooop"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-12 py-5 text-lg font-semibold rounded-full text-white bg-[#0066FF] hover:bg-[#0066FF]/90 transition-all shadow-[0_8px_30px_0_rgba(0,102,255,0.4)] hover:shadow-[0_10px_40px_rgba(0,102,255,0.5)] hover:transform hover:translate-y-[-2px]"
                aria-label="Download the App"
              >
                <Download className="mr-3 h-6 w-6" aria-hidden="true" />
                Download the App
              </a>
            </div>

            <nav className="flex flex-col sm:flex-row justify-center gap-4 mb-8 animate-fadeIn" style={{ animationDelay: "0.4s" }} aria-label="Primary navigation">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-white bg-[#0066FF] hover:bg-[#0066FF]/90 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
                aria-label="Submit Your Bid"
              >
                Submit Your Bid
                <ArrowRight className="ml-2 h-5 w-5" aria-hidden="true" />
              </a>
              <a
                href="https://chromewebstore.google.com/detail/deepseek/inhcgfpbfdjbjogdfjbclgolkmhnooop"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-[#0066FF] bg-white border-2 border-[#0066FF] hover:bg-blue-50 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
                aria-label="Download Now!"
              >
                Download Now!
                <Download className="ml-2 h-5 w-5" aria-hidden="true" />
              </a>
            </nav>

            <div className="flex flex-wrap justify-center gap-4 mb-8">
              <button 
                onClick={handleTagClick}
                className="px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium hover:bg-blue-200 transition-colors cursor-pointer"
              >
                DeepSeek AI Models
              </button>
              <button 
                onClick={handleTagClick}
                className="px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium hover:bg-blue-200 transition-colors cursor-pointer"
              >
                Premium AI Domain
              </button>
              <button 
                onClick={handleTagClick}
                className="px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium hover:bg-blue-200 transition-colors cursor-pointer"
              >
                AI Technology Investment
              </button>
            </div>
          </header>
          
          <section className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-24 animate-fadeIn" aria-label="Key Features" style={{ animationDelay: "0.6s" }}>
            <article className="p-8 rounded-xl bg-white/50 backdrop-blur-sm shadow-lg hover:shadow-xl transition-all" aria-labelledby="feature-1-title">
              <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-6 mx-auto">
                <Brain className="h-8 w-8 text-deepseek-primary" />
              </div>
              <h2 id="feature-1-title" className="text-2xl font-semibold mb-4">DeepSeek AI Technology</h2>
              <p className="text-gray-600">DeepSeek AI represents advanced neural networks and cutting-edge machine learning models that are revolutionizing the artificial intelligence landscape.</p>
            </article>
            <article className="p-8 rounded-xl bg-white/50 backdrop-blur-sm shadow-lg hover:shadow-xl transition-all" aria-labelledby="feature-2-title">
              <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-6 mx-auto">
                <Sparkles className="h-8 w-8 text-deepseek-primary" />
              </div>
              <h2 id="feature-2-title" className="text-2xl font-semibold mb-4">Premium Domain Value</h2>
              <p className="text-gray-600">The DeepSeek.ai domain offers exceptional branding potential for companies at the forefront of AI research, development and implementation.</p>
            </article>
            <article className="p-8 rounded-xl bg-white/50 backdrop-blur-sm shadow-lg hover:shadow-xl transition-all" aria-labelledby="feature-3-title">
              <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-6 mx-auto">
                <Zap className="h-8 w-8 text-deepseek-primary" />
              </div>
              <h2 id="feature-3-title" className="text-2xl font-semibold mb-4">Investment Opportunity</h2>
              <p className="text-gray-600">Secure this premium AI domain name and position your business at the cutting edge of artificial intelligence technology and innovation.</p>
            </article>
        </section>
          
        <div className="bg-white/70 backdrop-blur-sm rounded-xl p-6 mb-8 max-w-3xl mx-auto shadow-sm border border-blue-100">
          <h2 className="text-2xl font-semibold text-gray-900 mb-3">What is DeepSeek AI?</h2>
          <p className="text-lg text-gray-700">
            <strong>DeepSeek AI</strong> is an AI research company focused on cost-efficient, high-performance language models. It provides an open-source alternative to GPT-4, making AI technology more accessible to developers and businesses.
          </p>
        </div>

        <section className="mt-24 py-16 bg-white/80 rounded-3xl shadow-lg">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-center mb-8">DeepSeek AI Domain Benefits</h2>
            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-semibold mb-3">Perfect for AI Startups</h3>
                <p className="text-gray-700">The DeepSeek.ai domain is ideal for startups focusing on artificial intelligence, machine learning, and natural language processing technologies.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">Brand Recognition</h3>
                <p className="text-gray-700">DeepSeek AI as a name communicates depth of understanding and intelligence, perfect for AI-focused businesses aiming to make an impact in the market.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-3">Industry Relevance</h3>
                <p className="text-gray-700">With AI technology rapidly evolving, securing the DeepSeek.ai domain positions your company at the forefront of this technological revolution.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-24 py-16 bg-white/80 rounded-3xl shadow-lg">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-center mb-8">Why Choose DeepSeek.ai Domain?</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                    <TreeDeciduous className="h-5 w-5 text-green-500" />
                  </div>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Growing AI Market</h3>
                  <p className="text-gray-600">The artificial intelligence market is expanding rapidly, making this domain an increasingly valuable digital asset for businesses in the sector.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                    <Zap className="h-5 w-5 text-deepseek-primary" />
                  </div>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Memorable & Descriptive</h3>
                  <p className="text-gray-600">DeepSeek.ai clearly communicates advanced AI capabilities, making it both descriptive and easy to remember for customers and investors.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <section className="py-16 bg-gradient-to-r from-blue-50 via-indigo-50 to-blue-50 mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to Own DeepSeek.ai?</h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Contact us today to discuss your bid and secure this premium AI domain name for your business.
          </p>
          <a
            href="/contact"
            className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-white bg-[#0066FF] hover:bg-[#0066FF]/90 transition-all shadow-[0_4px_14px_0_rgba(0,102,255,0.39)] hover:shadow-[0_6px_20px_rgba(0,102,255,0.23)] hover:transform hover:translate-y-[-1px]"
            aria-label="Contact Us About DeepSeek.ai"
          >
            Contact Us
            <ArrowRight className="ml-2 h-5 w-5" aria-hidden="true" />
          </a>
        </div>
      </section>

      <WaitlistDialog 
        isOpen={isDialogOpen} 
        onClose={() => setIsDialogOpen(false)} 
      />
      
      <WhatsAppPromo
        isOpen={isWhatsAppPromoOpen}
        onClose={() => setIsWhatsAppPromoOpen(false)}
      />
    </main>
  );
};

export default Hero;


